import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { loadStripe } from '@stripe/stripe-js';
import { retry } from 'rxjs';
import { EnvironmentsService } from '../environments/environments.service';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private stripe: any;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentsService
  ) {
    loadStripe('pk_live_Kxt2ezjESxY6U9zTI0Rr74gZ').then((stripe) => {
      this.stripe = stripe;
    });
  }

  createPaymentIntent(items: any[]) {
    return this.http.post(`${this.environmentService.url}/v1.1/billing`, items);
  }

  confirmPayment(sessionId: string) {
    return this.http
      .get<{ status: string }>(
        `http://localhost:3000/check-payment-status/${sessionId}`
      )
      .pipe(
        retry({
          count: 10, // Retry 10 times
          delay: 3000, // Wait 3s between attempts
        })
      );
  }
}
